// Several booking forms can share a page, so their modality select is found by a data attribute rather than a page-unique
// id. The id is still accepted for the forms that use it.
export const MODALITY_SELECT_SELECTOR =
  "select[data-modality-select], select[id='modality']";

export const isModalitySelect = (element: Element) =>
  element.matches(MODALITY_SELECT_SELECTOR);
